import {VersionVariants} from '@jobseeker/lotus/enums';
import {BreadcrumbsProps as MUIBreadcrumbsProps} from '@mui/material';
import NotImplemented from '@jobseeker/lotus/elements/NotImplemented';
import V2 from './V2';

type OmmitedMuiProps = Omit<MUIBreadcrumbsProps, 'variant'>;
export interface BreadcrumbsProps extends OmmitedMuiProps {
  variant: VersionVariants;
  separator: string | JSX.Element;
  breadcrumbs: JSX.Element[];
  ariaLabel?: string;
}
const componentMap: any = {};
componentMap[VersionVariants.VERSION_ONE] = NotImplemented;
componentMap[VersionVariants.VERSION_TWO] = V2;

const Breadcrumbs = (props: BreadcrumbsProps) => {
  let Component;
  if (Object.keys(componentMap).includes(props.variant)) {
    Component = componentMap[props.variant];
  } else {
    Component = componentMap[VersionVariants.VERSION_ONE];
  }
  return <Component {...props} />;
};

export default Breadcrumbs;
